import { useMemo } from 'react';
import _, { isArray } from 'lodash';
import moment from 'moment';
import AutoCompleteTimeInput from './AutoCompleteTimeInput';

export default function TimeInput({ staticData, today, ...props }) {
  const itemList = useMemo(() => {
    if (isArray(staticData)) {
      return _.filter(staticData, (item) => item.dataKey === 'ServiceHourTimeslot')
        .map((item) => ({
          text: item.descEN,
          value: item.dataValue,
        }))
        .sort((itemA, itemB) =>
          moment(itemA?.text?.slice(0, 5), 'HH:mm').isBefore(moment(itemB?.text?.slice(0, 5), 'HH:mm')) ? -1 : 1
        )
        .filter((item) => {
          if (today) {
            return moment().isBefore(moment(item.text, 'HH:mm'), 'minute');
          } else return true;
        });
    }
  }, [staticData, today]);

  return <AutoCompleteTimeInput itemList={itemList} freeSolo clearOnblur {...props} />;
}
